import { callApi } from 'utils/callApi';
import { API_BASE_URL } from './index';

const GET_USER_QUESTIONS_URL = `${process.env.REACT_APP_API_BASE_URL}/web/users/get-questions`;
const GET_USER_POLL_QUESTIONS_URL = `${process.env.REACT_APP_API_BASE_URL}/web/users/get-poll-questions`;
const SAVE_ANSWERS_URL = `${process.env.REACT_APP_API_BASE_URL}/web/users/save-answers`;
const SAVE_POLL_ANSWERS_URL = `${process.env.REACT_APP_API_BASE_URL}/web/users/save-poll-question-answers`;
const SAVE_GALLERY_IMAGE_URL = `${process.env.REACT_APP_API_BASE_URL}/web/users/galleries/add`;
const GET_GALLERY_IMAGE_URL = `${process.env.REACT_APP_API_BASE_URL}/web/users/galleries`;
const DELETE_GALLERY_IMAGE_URL = `${process.env.REACT_APP_API_BASE_URL}/web/users/galleries`;
const USER_FILE_UPLOAD_URL = `${process.env.REACT_APP_API_BASE_URL}/web/file-upload`;

const SAVE_COLLAGE_IMAGE_URL = `${process.env.REACT_APP_API_BASE_URL}/web/users/collage/add`;
const GET_COLLAGE_IMAGE_URL = `${process.env.REACT_APP_API_BASE_URL}/web/users/collage`;
const DELETE_COLLAGE_IMAGE_URL = `${process.env.REACT_APP_API_BASE_URL}/web/users/collage`;
const UPDATE_USER_PROFILE = `${process.env.REACT_APP_API_BASE_URL}/web/users`;
const GET_USER_PROFILE = `${process.env.REACT_APP_API_BASE_URL}/web/users/get-user-profile`;

// eslint-disable-next-line import/prefer-default-export
export const getUserQuestions = () =>
    callApi({
        requestFunction: (axios) => axios.get(GET_USER_QUESTIONS_URL),
        successCode: 200,
        showToastOnSuccess: false,
        showToastOnError: true
    });

export const getUserPollQuestions = () =>
    callApi({
        requestFunction: (axios) => axios.get(GET_USER_POLL_QUESTIONS_URL),
        successCode: 200,
        showToastOnSuccess: false,
        showToastOnError: true
    });

export const saveUserAnswers = (payload) =>
    callApi({
        requestFunction: (axios) => axios.post(SAVE_ANSWERS_URL, payload),
        successCode: 200,
        showToastOnSuccess: true,
        showToastOnError: true
    });

export const saveUserPollQuestionsAnswers = (payload) =>
    callApi({
        requestFunction: (axios) => axios.post(SAVE_POLL_ANSWERS_URL, payload),
        successCode: 200,
        showToastOnSuccess: true,
        showToastOnError: true
    });

export const saveGalleryImageRequest = (payload) =>
    callApi({
        requestFunction: (axios) => axios.post(SAVE_GALLERY_IMAGE_URL, payload),
        successCode: 200,
        showToastOnSuccess: true,
        showToastOnError: true
    });

export const getGalleryImageRequest = () =>
    callApi({
        requestFunction: (axios) => axios.get(GET_GALLERY_IMAGE_URL),
        successCode: 200,
        showToastOnSuccess: false,
        showToastOnError: true
    });

export const deleteGalleryImageRequest = (imageId) =>
    callApi({
        requestFunction: (axios) => axios.delete(`${DELETE_GALLERY_IMAGE_URL}/${imageId}`),
        successCode: 200,
        showToastOnSuccess: true,
        showToastOnError: true
    });

export const userUploadFileRequest = async ({ file }) =>
    callApi({
        requestFunction: (axios) => {
            const formData = new FormData();
            formData.append('myFile', file);
            return axios.post(USER_FILE_UPLOAD_URL, formData);
        },
        successCode: 200,
        showToastOnSuccess: false,
        showToastOnError: true
    });

export const saveCollageImageRequest = (payload) =>
    callApi({
        requestFunction: (axios) => axios.post(SAVE_COLLAGE_IMAGE_URL, payload),
        successCode: 200,
        showToastOnSuccess: true,
        showToastOnError: true
    });

export const getCollageImageRequest = () =>
    callApi({
        requestFunction: (axios) => axios.get(GET_COLLAGE_IMAGE_URL),
        successCode: 200,
        showToastOnSuccess: false,
        showToastOnError: true
    });

export const deleteCollageImageRequest = (imageId) =>
    callApi({
        requestFunction: (axios) => axios.delete(`${DELETE_COLLAGE_IMAGE_URL}/${imageId}`),
        successCode: 200,
        showToastOnSuccess: true,
        showToastOnError: true
    });

export const updateUserProfileRequest = ({ userId, name, contactNumber, image }) =>
    callApi({
        requestFunction: (axios) =>
            axios.put(`${UPDATE_USER_PROFILE}/${userId}`, {
                name,
                contactNumber,
                image
            }),
        successCode: 200,
        showToastOnSuccess: true,
        showToastOnError: true
    });

export const getUserProfile = () =>
    callApi({
        requestFunction: (axios) => axios.get(`${GET_USER_PROFILE}`),
        successCode: 200,
        showToastOnSuccess: false,
        showToastOnError: true
    });
